const optionSeperator = ' - ';
const optionLabelFormat = (name: string, description: string) =>
    `${name}${optionSeperator}${description}`;
const optionValueFormat = (name: string, code: string) =>
    `${name}${optionSeperator}${code}`;

export interface StripeTaxCountryOption {
    label: string;
    value: string;
}

export interface StripeTaxCountryInfo {
    name: string;
    code: string;
}

export interface StripeTaxCountry extends StripeTaxCountryInfo {
    description: string;
}

export const stripeTaxCountriesOptions = (
    stripeTaxCountries: StripeTaxCountry[]
): StripeTaxCountryOption[] => {
    return stripeTaxCountries.map((c) => ({
        label: optionLabelFormat(c.name, c.description),
        value: optionValueFormat(c.name, c.code),
    }));
};

export const getCountryFromValue = (value: string): StripeTaxCountryInfo => {
    const substrings: string[] = value.split(optionSeperator);

    if (substrings.length !== 2)
        throw new Error(
            `Cannot parse the following country option value: ${value}`
        );

    return { name: substrings[0], code: substrings[1] };
};
